// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_Uh3","cls2":"CiterightLanding-cls2_kmt CiterightLanding-cls1_Uh3"};